import React, { useEffect } from 'react';
import { fetchStoreInfoBySubDomain } from 'src/redux/actions';
import Error404 from '@/containers/404Page/index';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';

const ErrorPage = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const domainName = router.query.domain;

  useEffect(() => {
    if (domainName) {
      dispatch(fetchStoreInfoBySubDomain(domainName));
    }
  }, [domainName]);

  return (
    <>
      <Error404 />
    </>
  );
};

export default ErrorPage;
